declare global {
  interface Window {
    RNParams: {
      // introduced on 5.June 2025, iOS version 1.5.0
      enableNativeCheckin: boolean;
    };
  }
}

export const RNParams = {
  isNativeCheckinEnabled: () => {
    return window.RNParams?.enableNativeCheckin ?? false;
  },
};
